import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import Typography from '@material-ui/core/Typography';
import GenericTable from '../../Components/GenericTable';
import { Paths } from '../../Routes/routePaths'
import { UserServices } from '../../Services/UserServices';
import { Pagination } from '@material-ui/lab';
import OutlinedButton from 'Components/OutlinedButton';
import SearchBoxInput from 'Components/SearchBoxInput';
import { useHistory } from 'react-router';
import commonStyles from 'theme/commonStyles';

const userServices = new UserServices();

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        width: '100%',
        boxSizing: 'border-box',
        [theme.breakpoints.up('sm')]: {
            minHeight: 180,
        },
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: '100%',
        maxWidth: 174,
        height: 'auto',
        maxHeight: 132,
        paddingTop: 17,
        marginTop: 16,
        marginLeft: 0,
        borderRadius: 5,
        objectFit: 'contain',
        [theme.breakpoints.up('sm')]: {
            marginTop: 25,
            marginLeft: 20,
        },
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    cardTitle: {
        color: "#808080"
    },
    cardSubTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: "#3D7DDD",
    },
    pageTitle: {
        marginBottom: theme.spacing(3),
        wordBreak: 'break-word',
    }
}));

const columns = [
    { label: "First name", key: 'firstName' },
    { label: "Surname", key: 'lastName' },
    { label: "Username", key: 'userName' },
    { label: "Location", key: "location" },
    { label: "Email", key: "email" },
    { label: "User Role", key: "role" },
    { label: "Action", key: "action", actions: ["edit"] }
];

const Users = () => {

    const classes = useStyles();
    const history = useHistory();
    const commonClasses = commonStyles();

    const [filterState, setFilterState] = React.useState({ page: 1, search: "" });
    const [administratorList, setUsersList] = React.useState([]);
    const [pagination, setPagination] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
    }, []);

    const getAllUser = async (queryData) => {
        let query = `search=${queryData.search}&page=${queryData.page}`;
        const userResult = await userServices.getAllUser(`main/userlist?${query}`);
        if (userResult && userResult.results) {
            setUsersList(userResult.results);
            setPagination(userResult.pagination);
        }
        setLoading(false);
    };

    const handlePageChange = (evt, page) => {
        setFilterState({ ...filterState, page });
        return getAllUser({ ...filterState, page });
    };

    const handleSearch = e => {
        e.preventDefault();
        setLoading(true);
        return getAllUser({ ...filterState, page: 1 });
    };

    const handleItemClick = (row, action) => {
        if (!row) return null;
        history.push(Paths.EditUsers + '/' + row.uuid);
    }

    const handleCreateNew = () => {
        history.push(Paths.AddUsers);
    }

    React.useEffect(() => {
        const getData = setTimeout(() => {
            getAllUser({ page: 1, search: filterState.search });
        }, 800);
        return () => clearTimeout(getData);
    }, [filterState.search]);

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <Typography variant="h4" className={classes.pageTitle}>Users</Typography>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item xs={12} sm={6} md={4}>
                            <SearchBoxInput
                                value={filterState.search}
                                handleChange={(evt) => {
                                    setFilterState({ ...filterState, search: evt.target.value })
                                    // return getAllUser({ search: evt.target.value, page: 1});
                                }}
                                handleSearch={handleSearch}
                            />
                        </Grid>
                        <Grid item xs={12} sm="auto">
                            <OutlinedButton
                                title={"Create User"}
                                handleClick={handleCreateNew}
                                align={'right'}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: 20 }}>
                        <GenericTable
                            columns={columns}
                            loading={loading}
                            handleItemClick={handleItemClick}
                            list={administratorList}
                        />
                    </Grid>
                    <Grid container style={{ marginTop: 22 }} >
                        {pagination &&
                            <Pagination
                                onChange={handlePageChange}
                                style={{ margin: "0 auto" }}
                                count={parseInt(pagination?.total_pages || 0)}
                                variant="outlined"
                                shape="rounded"
                                siblingCount={0}
                            />}
                    </Grid>
                </div>
            </main>
        </Layout>
    );
}

export default Users;